import type { ReactNode } from "react";
import { Icon } from "../icons";
import type { IconName } from "../icons";

export type EmptyStateProps = {
  icon?: IconName | null;
  title: string;
  text?: string | null;
  action?: ReactNode;
  className?: string;
};

export function EmptyState({ icon = null, title, text = null, action, className }: EmptyStateProps) {
  return (
    <div className={["fxmap-empty", className ?? ""].filter(Boolean).join(" ")} role="status">
      {icon !== null ? <Icon name={icon} className="fxmap-empty-icon" /> : null}
      <p className="fxmap-empty-title">{title}</p>
      {text !== null ? <p className="fxmap-empty-text fxmap-muted">{text}</p> : null}
      {action !== undefined ? <div className="fxmap-empty-action">{action}</div> : null}
    </div>
  );
}
